import { PositionTypes } from 'components/Elements/elements.types';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

const IconWrapper = styled.span<{
  $cursorPointer?: boolean;
  $height?: string;
  $position?: PositionTypes;
  $color?: string;
  $textColor?: string;
  $margin?: string;
}>`
  ${(props) => props.$cursorPointer && 'cursor: pointer;'}
  ${(props) => props.$textColor && `color: ${props.$textColor};`}
  ${(props) => props.$margin && `margin: ${props.$margin};`}

  display: inline-flex;
  align-items: center;

  svg {
    opacity: 0.54;
    ${(props) => props.$height && `height: ${props.$height};`}
    ${(props) => props.$position && `position: ${props.$position};`}
    ${(props) => props.$color && `color: ${props.$color};`}

    &:hover {
      opacity: 1;
    }
  }

  &:hover {
    svg {
      opacity: 1;
    }
  }
`;

interface IconProps {
  onClick?: () => void;
  icon?: ReactNode;
  imgIcon?: string;
  altText?: string;
  label?: ReactNode;
  height?: string;
  position?: PositionTypes;
  color?: string;
  textColor?: string;
  margin?: string;
  useCursorPointer?: boolean;
}

const CustomIcon = ({
  onClick,
  icon,
  imgIcon,
  altText,
  label,
  height,
  position,
  color,
  textColor,
  margin,
  useCursorPointer,
}: IconProps) => (
  <IconWrapper
    $cursorPointer={!!onClick || useCursorPointer}
    onClick={onClick}
    $height={height}
    $position={position}
    $color={color}
    $textColor={textColor}
    $margin={margin}
  >
    {imgIcon && <img src={imgIcon} alt={altText ?? `${imgIcon}`} />}
    {icon && icon}
    &nbsp;
    {label}
  </IconWrapper>
);

export default CustomIcon;
